var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 253,
    height: 422,
    viewBox: "0 0 253 422",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.279 39.553C133.162 33.8214 136.467 26.7974 135.914 18.9267C134.323 -3.75081 102.755 1.23796 96.6146 12.6836C90.474 24.1293 91.2037 53.1622 99.1399 55.2079C102.305 56.0237 109.047 54.0253 115.909 49.8892L111.602 80.3609H137.034L128.279 39.553Z",
    fill: "#B28B67"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.637 21.4311C113.664 34.992 111.088 41.7724 106.912 41.7724C100.646 41.7724 95.3299 37.7948 92.5807 37.7948C90.5766 37.7948 91.024 40.3027 92.3525 42.1621C93.4484 43.6963 98.7858 45.1749 98.7858 47.5533C98.7858 49.9317 94.5688 48.0917 94.5688 49.5023C94.5688 51.8355 93.8277 56.2225 97.8773 56.2225C101.976 56.2225 113.726 54.7289 115.74 48.6463C117.04 44.7207 117.88 36.5862 118.261 24.2428C118.51 24.2132 118.763 24.198 119.019 24.198C122.531 24.198 125.377 27.0446 125.377 30.5561C125.377 32.3387 124.644 33.9499 123.462 35.1044C124.933 37.181 126.582 39.3502 128.471 41.5886C135.569 37.3302 140.836 24.8645 133.896 12.8895C131.978 7.02307 127.636 3.88961 122.508 2.43464C118.354 0.696995 114.042 0.501074 110.402 1.54278C103.266 2.15484 96.8942 4.33072 95.0883 5.62292C95.0883 12.3786 96.3973 14.383 107.578 14.2063C110.325 15.6572 112.437 18.1556 114.637 21.4311Z",
    fill: "#191847"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.512 168.314L107.093 303.133L79.0627 402.502H58.6183L88.4048 168.314H145.512Z",
    fill: "#191847"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.785 168.314C156.674 237.801 159.704 275.702 160.637 282.015C161.57 288.328 175.678 328.491 202.96 402.502H181.781C147.049 331.501 127.66 291.338 123.616 282.015C119.571 272.692 107.089 234.791 88.2887 168.314H155.785Z",
    fill: "#2F3676"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.854 421.576L203.794 399.323H181.541C170.989 406.741 157.213 412.746 140.213 417.338V421.576H180.481L194.257 419.457V421.576H204.854Z",
    fill: "#191847"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.9316 421.576L80.872 399.323H58.6188C48.067 406.741 34.2912 412.746 17.2915 417.338V421.576H57.5591L71.3349 419.457V421.576H81.9316Z",
    fill: "#191847"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1178 150.946L24.1298 178.065C15.157 181.172 7.73097 184.777 1.85182 188.879C0.494751 190.301 -1.06998 193.098 4.90883 192.215C10.8876 191.333 17.2161 190.673 18.1889 192.666C19.1617 194.658 15.6955 197.364 17.5656 200.013C18.8123 201.779 23.7696 196.786 32.4375 185.032L64.8603 168.851L56.1178 150.946ZM200.967 139.211L182.198 141.937C202.345 185.648 213.145 208.765 214.6 211.288C217.874 216.964 214.024 226.851 212.519 232.085C220.126 234.281 217.696 222.529 227.314 225.46C236.094 228.136 243.338 234.201 252.033 226.989C253.102 226.102 254.003 223.202 250.605 221.513C242.14 217.304 229.711 209.602 227.779 206.763C225.145 202.892 216.207 180.375 200.967 139.211Z",
    fill: "#B28B67"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.521 62.6981L110.891 58.8521C95.1151 98.2617 71.5871 136.392 32.2767 168.6L41.9977 185.371C76.5459 165.02 109.25 149.211 122.521 118.673C126.975 108.424 122.884 74.9532 122.521 62.6981Z",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.466 173.612C129.151 177.144 102.929 177.144 83.7995 173.612C81.4295 173.174 81.0556 169.206 82.1547 166.513C99.2707 124.575 111.008 87.9814 111.008 58.8521C114.148 60.4354 119.645 60.6726 127.497 59.5639C148.599 89.5827 158.299 124.026 162.466 173.612Z",
    fill: "#323337"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.743 57.0482H123.949C121.901 69.0912 115.443 232.173 95.5047 285.52H203.385C201.046 236.65 182.597 177.944 163.908 128.818C180.434 143.941 194.837 169.565 207.119 205.692L227.326 200.505C212.301 135.762 181.411 88.176 134.654 57.7465C134.552 57.5126 134.452 57.2798 134.351 57.0482H133.573C133.287 56.8643 133 56.6811 132.712 56.4985L132.743 57.0482Z",
    fill: "#DDE3E9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient);
export default __webpack_public_path__ + "static/media/client.cb8e04e637db8c7ce8db2b2f174ed79e.svg";
export { ForwardRef as ReactComponent };